import React from "react";
import LegalLayout from "@/components/pnp/LegalLayout";
import { CONTACT } from "@/lib/pnp";

export default function Impressum() {
  return (
    <LegalLayout kicker="Rechtliches · § 5 TMG" title="Impressum">
      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Angaben gemäß § 5 TMG</h2>
      <p>
        Paul Drechsler
        <br />
        P&amp;P Gartenservice
        <br />
        Schelkenwiese 32
        <br />
        35305 Grünberg
        <br />
        Deutschland
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Kontakt</h2>
      <p>
        Telefon: <a className="text-[#17C964] hover:underline" href={CONTACT.telHref}>{CONTACT.phone}</a>
        <br />
        WhatsApp: <a className="text-[#17C964] hover:underline" href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer">{CONTACT.phone}</a>
        <br />
        E-Mail: <a className="text-[#17C964] hover:underline" href={CONTACT.emailHref}>{CONTACT.email}</a>
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Unternehmensform</h2>
      <p>
        Kleingewerbe · Kleinunternehmerregelung gemäß § 19 UStG.
        Es wird keine Umsatzsteuer ausgewiesen und nicht in Rechnung gestellt.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
      </h2>
      <p>
        Paul Drechsler
        <br />
        Schelkenwiese 32
        <br />
        35305 Grünberg
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
        bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#17C964] hover:underline"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">
        Verbraucherstreitbeilegung / Universalschlichtungsstelle
      </h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
        Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind
        wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
        fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
        keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
        Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
        Anbieter oder Betreiber der Seiten verantwortlich.
      </p>

      <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-[#082E19]">Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>

      <p className="mt-12 text-[#4F6858] text-sm">
        Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
      </p>
    </LegalLayout>
  );
}
